import { render, staticRenderFns } from "./applicationRecords.vue?vue&type=template&id=5a448fb7&scoped=true"
import script from "./applicationRecords.vue?vue&type=script&lang=js"
export * from "./applicationRecords.vue?vue&type=script&lang=js"
import style0 from "./applicationRecords.vue?vue&type=style&index=0&id=5a448fb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a448fb7",
  null
  
)

export default component.exports